import { render, staticRenderFns } from "./videoList.vue?vue&type=template&id=7a66cfd4"
import script from "./videoList.vue?vue&type=script&lang=ts"
export * from "./videoList.vue?vue&type=script&lang=ts"
import style0 from "./videoList.vue?vue&type=style&index=0&id=7a66cfd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports